const SITE_KEY = process.env.VUE_APP_RECAPTCHA_SITE_KEY || '';

let loadPromise: Promise<void> | null = null;

function ensureLoaded(): Promise<void> {
  if (!SITE_KEY) return Promise.resolve();
  if (loadPromise) return loadPromise;
  loadPromise = new Promise((resolve, reject) => {
    if ((window as any).grecaptcha) { resolve(); return; }
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.onload = () => resolve();
    script.onerror = () => { loadPromise = null; reject(new Error('reCAPTCHA load failed')); };
    document.head.appendChild(script);
  });
  return loadPromise;
}

export function useRecaptcha() {
  async function getToken(action: string): Promise<string> {
    if (!SITE_KEY) return '';
    try {
      await ensureLoaded();
      return await new Promise<string>((resolve) => {
        (window as any).grecaptcha.ready(async () => {
          const token = await (window as any).grecaptcha.execute(SITE_KEY, { action });
          resolve(token);
        });
      });
    } catch {
      return '';
    }
  }

  return { getToken };
}
